import { render, staticRenderFns } from "./SelectMultiple.vue?vue&type=template&id=2ffa4074&scoped=true&lang=pug&"
import script from "./SelectMultiple.vue?vue&type=script&lang=ts&"
export * from "./SelectMultiple.vue?vue&type=script&lang=ts&"
import style0 from "./SelectMultiple.vue?vue&type=style&index=0&id=2ffa4074&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffa4074",
  null
  
)

export default component.exports